import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "confirmModalLabel"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "modal fade",
      id: _ctx.getModalId,
      tabindex: "-1",
      "aria-labelledby": "confirmModalLabel",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1),
            _cache[2] || (_cache[2] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.text), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
              class: "btn btn-secondary"
            }, "Zrušit"),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args))),
              class: "btn btn-primary"
            }, "Potvrdit")
          ])
        ])
      ])
    ], 8, _hoisted_1)
  ]))
}